<div class="scroll-top-box">
    <div class="pst-relative">
        <p (click)="scrollTop()" class="btn-scroll-top">
            ^
        </p>
        <p class="advise" id="up-btn-advise">
            Haz doble click para ir hasta el inicio
        </p>
    </div>
</div>